// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606101112/js/" + chunkId + "." + {"44":"e720496a","225":"d8e5fb0c","481":"3a8f552a","486":"5560116d","770":"a73e8398"}[chunkId] + ".0.5006704674052542.chunk.js";
};